( function() {
    "use strict";


    angular.module('SmartAdmin.Forms').directive('bootstrapAttributeForm', function(){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/_common/forms/directives/bootstrap-validation/bootstrap-attribute-form.tpl.html',
            link: function(scope, form){
                form.bootstrapValidator();


            }

        }
    });
})();
